/**
 * Default size is 18px
 */
export function iconProps(size: number = 18) {
  return { size, stroke: 1.5 };
}
